<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <router-link :class="b('', { view })" :to="to">
    {{ $t(label) }}
  </router-link>
</template>
